module.exports = __webpack_public_path__ + "static/media/ledger.cfb26aca.svg";